import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-child-case-study',
  templateUrl: './view-child-case-study.component.html',
  styleUrls: ['./view-child-case-study.component.scss']
})
export class ViewChildCaseStudyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
